import { Component, OnInit } from '@angular/core';
import { LegalService } from '@greco/ngx-platform-legal';
import { LegalDocument } from '@greco/platform-legal';

@Component({
  selector: 'greco-terms-page',
  templateUrl: './terms.page.html',
  styleUrls: ['./terms.page.scss'],
})
export class TermsPage implements OnInit {
  constructor(private legalSvc: LegalService) {}

  document: LegalDocument | null = null;

  async ngOnInit() {
    this.document = await this.legalSvc.getTermsOfService();
  }
}
